module.exports = __webpack_public_path__ + "static/img/icon6.2e90e774.svg";